import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Taxonomy } from '@uncinc/react-drupal-core';
import classNames from 'classnames';

const Milestone = ({ entities }) => {
  return (
    <Container className="MilestoneContent">
      <div className="row MilestoneContent__Items">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const classes = classNames('col-12 col-md-6 col-xl-4 Milestone');

          return (
            <div key={`${uuid}:${langcode}`} className={classes}>
              <Taxonomy
                id={id}
                key={`${uuid}:${langcode}`}
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Milestone;
